import PropTypes from 'prop-types'

import { Radio, RadioControl } from '@redriverpress/system'

import Field from './Field'

export default function RadioField({ label, as, ...props }) {
  const component = as || (label ? Radio : RadioControl)
  return <Field as={component} type='radio' label={label} mb={0} {...props} />
}

RadioField.defaultProps = {
  label: null,
  as: null,
}

RadioField.propTypes = {
  label: PropTypes.string,
  as: PropTypes.func,
}
